import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { EvaluationsCoachingData } from './qm-evaluations-coaching.model';

@Injectable({
    providedIn: 'root'
})
export class QmEvaluationsCoachingService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    async loadData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean, abort?: Promise<void>) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render endpoint");
            throw error;
        }
        try {
            const url = "/api/v2/dashboards/modules/evaluationsCoaching/"
                + encodeURIComponent(moduleKey) + "?isAutoRefresh=" + isAutoRefresh + "&isFirstLoad=" + isFirstLoad;
            const response = await this.cvApiService.get<EvaluationsCoachingData[]>(url, renderEndpoint, abort);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting Evaluations and coaching data");
            throw error;
        }
    }

    async getDataForExport(moduleKey: string, format: string, isCXOne: boolean) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = '/api/v2/dashboards/modules/evaluationsCoaching/'+ moduleKey+'/export?format=' + format + '&isCXOne=' + isCXOne;
            const response = await this.cvApiService.get<string[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data to export evaluations and coaching module");
            throw err;
        }
    }
}
